import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//context
import {ListContext} from '@/context/ListContext';



const WebPageWidget = () => {
    
    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.WEB_PAGE} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=Web&position=${isMainMenu ? 'end' : 'start'}`} />
        </div>
    )
}
export default WebPageWidget